<template>
	<div>
		<vxe-modal v-model="modal" width="400" title="选择部门" show-footer @show="show">
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="变更后部门">
						<el-select v-model="form.takedepartment" placeholder="请选择" clearable>
							<el-option v-for="item in department" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>	
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'takedepartmentIndex',
		props: {
			billIDs: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal:false,
				department: [],
				takedepartment:null,
				form:{
					takedepartment:null
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			init() {
				this.department = window.systemData.department.filter((item)=>{
					return item.parentid == 29
				})
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			submit(){
				if(!this.form.takedepartment){
					this.$message.error('请选择部门')
				}
				this.$api.takegoods.updatefromlist(0,{
					takedepartment:this.form.takedepartment,
					billIDs:this.billIDs,
				}).then(()=>{
					this.$emit('success')
					this.cancel()
					this.$message.success('操作成功')
				})

			}
		},
		components: {
			
		}
	}
</script>